import React, { useState, useEffect } from "react";
import axios from "axios";

const AttendanceReport = () => {
    const [filterType, setFilterType] = useState("today");
    const [data, setData] = useState([]);
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [date, setDate] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [filterType]);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem("user-origin");
    const token = userInfo?.token;

    const fetchData = async () => {
        let url = "";
        if (filterType === "today") {
            url = "/api/attendance/today";
        } else if (filterType === "monthly" && month && year) {
            url = `/api/attendance/monthly?month=${month}&year=${year}`;
        } else if (filterType === "daily" && date) {
            url = `/api/attendance/daily?date=${date}`;
        }

        if (url) {
            try {
                const res = await axios.get(`${backendUrl}${url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Tenant-Origin": origin,
                    },
                });
                setData(res.data);
            } catch (error) {
                console.error("Error fetching attendance:", error);
            }
        }
    };

    // Month options for dropdown
    const monthOptions = [
        { value: "", label: "Select Month" },
        { value: "1", label: "January" },
        { value: "2", label: "February" },
        { value: "3", label: "March" },
        { value: "4", label: "April" },
        { value: "5", label: "May" },
        { value: "6", label: "June" },
        { value: "7", label: "July" },
        { value: "8", label: "August" },
        { value: "9", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];

    // Get current year and generate year options
    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let i = currentYear - 5; i <= currentYear + 1; i++) {
        yearOptions.push(i);
    }

    // Filter data based on search term
    const filteredData = Array.isArray(data) ? data.filter(item => {
        const fullName = `${item.employee?.first_name || ''} ${item.employee?.last_name || ''}`.toLowerCase();
        return fullName.includes(searchTerm.toLowerCase()) ||
            (item.date && item.date.includes(searchTerm)) ||
            (item.status && item.status.toLowerCase().includes(searchTerm.toLowerCase()));
    }) : [];

    const handleClearFilters = () => {
        setMonth("");
        setYear("");
        setDate("");
        setSearchTerm("");
        fetchData();
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Attendance Report</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="#">Employees</a></li>
                                        <li className="breadcrumb-item active">Attendance Report</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title mb-4">Attendance Filters</h4>

                                    {/* Filter Type Selection */}
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <div className="btn-group" role="group">
                                                <button
                                                    type="button"
                                                    onClick={() => setFilterType("today")}
                                                    className={`btn ${filterType === "today" ? "btn-primary" : "btn-outline-primary"}`}
                                                >
                                                    <i className="bx bx-calendar-event me-1"></i> Today
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setFilterType("monthly")}
                                                    className={`btn ${filterType === "monthly" ? "btn-primary" : "btn-outline-primary"}`}
                                                >
                                                    <i className="bx bx-calendar me-1"></i> Monthly
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setFilterType("daily")}
                                                    className={`btn ${filterType === "daily" ? "btn-primary" : "btn-outline-primary"}`}
                                                >
                                                    <i className="bx bx-sun me-1"></i> Daily
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Filter Inputs */}
                                    <div className="row">
                                        {filterType === "monthly" && (
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label htmlFor="monthSelect" className="form-label">Month</label>
                                                        <select
                                                            className="form-select"
                                                            id="monthSelect"
                                                            value={month}
                                                            onChange={(e) => setMonth(e.target.value)}
                                                        >
                                                            {monthOptions.map(option => (
                                                                <option key={option.value} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="yearSelect" className="form-label">Year</label>
                                                        <select
                                                            className="form-select"
                                                            id="yearSelect"
                                                            value={year}
                                                            onChange={(e) => setYear(e.target.value)}
                                                        >
                                                            <option value="">Select Year</option>
                                                            {yearOptions.map(year => (
                                                                <option key={year} value={year}>
                                                                    {year}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {filterType === "daily" && (
                                            <div className="col-md-4">
                                                <label htmlFor="dateInput" className="form-label">Select Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    id="dateInput"
                                                    value={date}
                                                    onChange={(e) => setDate(e.target.value)}
                                                />
                                            </div>
                                        )}

                                        {(filterType === "monthly" || filterType === "daily") && (
                                            <div className="col-md-4 d-flex align-items-end gap-2">
                                                <button
                                                    onClick={fetchData}
                                                    className="btn btn-success"
                                                    disabled={
                                                        (filterType === "monthly" && (!month || !year)) ||
                                                        (filterType === "daily" && !date)
                                                    }
                                                >
                                                    <i className="bx bx-filter me-1"></i> Apply Filter
                                                </button>
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={handleClearFilters}
                                                >
                                                    Clear Filters
                                                </button>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Attendance Table */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <h4 className="card-title">Attendance Records</h4>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search employee, date or status..."
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-hover table-check table-list">
                                            <thead className="table-sales-gradient">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle">Date</th>

                                                    <th className="align-middle">Employee</th>
                                                    {/* <th className="align-middle">In Time</th>
                                                    <th className="align-middle">Out Time</th> */}
                                                    <th className="align-middle">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredData.length > 0 ? (
                                                    filteredData.map((row, idx) => (
                                                        <tr key={idx}>
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`clientCheck${idx}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`clientCheck${idx}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{idx + 1}</td>
                                                            <td>{row.date}</td>

                                                            <td>
                                                                {row.employee?.first_name}{" "}
                                                                {row.employee?.last_name}
                                                            </td>
                                                            {/* <td>{row.in_time || "-"}</td>
                                                            <td>{row.out_time || "-"}</td> */}
                                                            <td>
                                                                <span
                                                                    className={`badge rounded-pill font-size-12 ${row.status === "Present"
                                                                        ? "bg-success"
                                                                        : row.status === "Absent"
                                                                            ? "bg-danger"
                                                                            : row.status === "Leave"
                                                                                ? "bg-warning"
                                                                                : row.status === "Half Day"
                                                                                    ? "bg-info"
                                                                                    : "bg-secondary"
                                                                        }`}
                                                                >
                                                                    {row.status}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center p-3">
                                                            {searchTerm ? "No matching records found" : "No records found"}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AttendanceReport;

